module.exports = __webpack_public_path__ + "media/images/flags/64/NATO-3f1a5ab5e47e99b4fe082234bb0a26fd.png";